import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import MediaQuery from "cms/components/MediaQuery";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import OptimizedVideo from "index";

import {
  Container,
  Content,
  IconImageContainer,
  Message,
  Tagline,
  Headline,
  Pitch,
  Link,
  Illustration,
  CardVariant,
} from "./OneCardBlock.styles";

export interface OneCardBlockProps extends Queries.SanityOneCardBlock {}

const OneCardBlock: React.FC<OneCardBlockProps> = ({
  cardVariant,
  headline,
  tagline,
  _rawPitch,
  button,
  image,
  imageAlt,
  imageMobile,
  imageMobileAlt,
  iconImage,
  iconImageAlt,
  video,
  videoAlt,
}) => (
  <Container>
    {/* <pre>
      {JSON.stringify({
        headline,
        cardDescription,
        image,
        imageAlt,
        iconImage,
        iconImageAlt,
      }, null, 2)}
    </pre> */}
    <Content $cardVariant={cardVariant as CardVariant}>
      {iconImage && (
        <IconImageContainer>
          <OptimizedImage image={iconImage} alt={iconImageAlt} />
        </IconImageContainer>
      )}

      <Message $cardVariant={cardVariant as CardVariant}>
        {tagline && <Tagline>{tagline}</Tagline>}
        <Headline $cardVariant={cardVariant as CardVariant}>
          {headline}
        </Headline>

        {_rawPitch && (
          <Pitch $cardVariant={cardVariant as CardVariant}>
            <RichText text={_rawPitch} />
          </Pitch>
        )}
      </Message>

      {button?.url && button.label && (
        <Link href={button.url}>
          <Button
            label={button.label}
            variant={button.variant as ButtonVariant}
          />
        </Link>
      )}

      {(video || imageMobile || image) && (
        <Illustration>
          {video && (
            <OptimizedVideo
              video={video}
              style={{ maxWidth: "100%" }}
              alt={videoAlt}
            />
          )}

          {!video && imageMobile && (
            <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
              <OptimizedImage image={imageMobile} alt={imageMobileAlt} />
            </MediaQuery>
          )}

          {!video && !imageMobile && image && (
            <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
              <OptimizedImage image={image} alt={imageMobileAlt} />
            </MediaQuery>
          )}

          {!video && image && (
            <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
              <OptimizedImage image={image} alt={imageAlt} />
            </MediaQuery>
          )}
        </Illustration>
      )}
    </Content>
  </Container>
);

export const query = graphql`
  fragment OneCardBlock on SanityOneCardBlock {
    _key
    _type
    cardVariant
    headline
    tagline
    _rawPitch(resolveReferences: { maxDepth: 5})
    button {
      variant
      label
      url
    }
    image {...OptimizedImage}
    imageAlt
    imageMobile {...OptimizedImage}
    imageMobileAlt
    iconImage {...OptimizedImage}
    iconImageAlt
    video {...OptimizedVideo}
    videoAlt
  }
`;

export default OneCardBlock;
